import { Component } from '@angular/core';
import { ConfigSettingsService } from '@ebeihilfe/core';

@Component({
    selector: 'portal-login',
    styleUrls: ['./login.component.scss'],
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent {
  constructor(private config: ConfigSettingsService) {}

  public get isPasswordGrantAvailable(): boolean {
    return this.config.appSettings.supportedOAuthGrants.has('password');
  }
}
